import { useQuery } from '@tanstack/react-query';
import { getGamePackDetail } from 'services/scratcherService';
import GameSummaryModel, { GameSummaryData } from 'models/scratcher/GameSummaryModel';

export function useGameSummary(storeId?: string, gameId?: string) {
  const queryResult = useQuery<GameSummaryModel, Error>({
    queryKey: ['game-summary', storeId, gameId],
    queryFn: async () => {
      if (!storeId || !gameId) {
        return GameSummaryModel.createEmpty();
      }

      const response = await getGamePackDetail(storeId, gameId);
      if (response.success && response.data) {
        return GameSummaryModel.fromServerData(response.data);
      }

      throw new Error(response.error || 'Failed to load game summary');
    },
    enabled: Boolean(storeId && gameId),
    staleTime: 1 * 60 * 1000,
  });

  const summaryModel = queryResult.data ?? GameSummaryModel.createEmpty();

  return {
    summaryModel,
    summaryData: summaryModel.toSummaryData(),
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error ?? null,
  };
}

